/**
 * Runtime configuration.
 *
 * Values come from window.ENV, written by the container's entrypoint at start
 * up, so one built image can be deployed to any environment. The Vite env vars
 * are the development fallback.
 */

declare global {
  interface Window {
    ENV?: Record<string, string | undefined>;
  }
}

function setting(key: string, fallback: string): string {
  const runtime = window.ENV?.[key];
  if (runtime && !runtime.startsWith('__')) return runtime;
  const buildTime = import.meta.env?.[key] as string | undefined;
  return buildTime ?? fallback;
}

export const config = {
  apiBaseUrl: setting('VITE_API_BASE_URL', 'http://localhost:8080'),
  keycloakUrl: setting('VITE_KEYCLOAK_URL', 'https://auth.vikingvault.dev'),
  keycloakRealm: setting('VITE_KEYCLOAK_REALM', 'vikingvault'),
  keycloakClientId: setting('VITE_KEYCLOAK_CLIENT_ID', 'floor-plan-editor'),
};
